module.exports = __webpack_public_path__ + "ca74926cf54e45942af6fde4d6e47d6c.jpg";